import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import { t } from '../../../../types/translation/Translator';
import { ContainerContext } from '../../../../context/ContainerContext';
import { useNavigate } from 'react-router-dom';
import { Container } from '../../../../types/container';
import { StockLocationContext } from '../../../../context/StockLocationContext';
import Table from '../../../components/Table/Table';
import { ContainerTypeContext } from '../../../../context/ContainerTypeContext';
import { BinContext } from '../../../../context/BinContext';
import { ContainerFilter } from '../../../../VentoryUI/components/filters/ContainerFilter/ContainerFilter';
import { BinStatusContext } from '../../../../context/BinStatusContext';
import { TagRelationContext } from '../../../../context/TagRelationContext';
import { CustomFieldContext } from '../../../../context/CustomFieldContext';
import { Routing } from '../../../../util/routes.util';
import { SearchFilter } from '../../../components/Filter';
import { CreateButton } from '../../../components/Button';
import { IconButton, SettingsIconButton } from '../../../icons';
import { CompanyRoleAssignmentContext } from '../../../../context/CompanyRoleAssignmentContext';
import { IconType } from '../../../icons/Icon';
import ContainerQuickActionModal from './QuickAction/ContainerQuickActionModal';
import { StockLocationRoleAssignmentContext } from '../../../../context/StockLocationRoleAssignmentContext';
import { StockLocationRole } from '../../../../types/stock_location_role_assignment';
import { CompanyContext } from '../../../../context/CompanyContext';
import { TableSettingsContext } from '../../../../context/TableSettingsContext';
import { EntityType } from '../../../../types/comment';
import { containerTableHeaders } from '../../../components/Table/Container/ContainerTable';
import { UserContext } from '../../../../context/UserContext';

interface ContainerOverviewProps {}

export default function ContainerOverviewPane({}: ContainerOverviewProps) {
  const navigate = useNavigate();

  const { isAdmin } = useContext(CompanyRoleAssignmentContext);
  const { currentCompany, companies } = useContext(CompanyContext);
  const { containerTypes, containerTypesLoading } = useContext(ContainerTypeContext);
  const { containers, containersLoading } = useContext(ContainerContext);
  const { stockLocations } = useContext(StockLocationContext);
  const { binStatuses } = useContext(BinStatusContext);
  const { bins } = useContext(BinContext);
  const { tagRelations } = useContext(TagRelationContext);
  const { customFields } = useContext(CustomFieldContext);
  const { hasStockLocationRole } = useContext(StockLocationRoleAssignmentContext);
  const { getTableSettings } = useContext(TableSettingsContext);
  const { locale } = useContext(UserContext);

  const tableSettings = getTableSettings(EntityType.container, currentCompany.id);

  const allItems = useMemo(() => {
    return [...containers.values()].filter(
      c =>
        currentCompany.partner ||
        hasStockLocationRole(c.companyId, c.stockLocationId, StockLocationRole.STOCK_LOCATION_VIEWER),
    );
  }, [containers]);

  const [items, setItems] = useState<Container[]>(allItems);
  const [modalOpen, setModalOpen] = useState(false);

  const filter = new ContainerFilter(
    stockLocations,
    bins,
    containerTypes,
    binStatuses,
    tagRelations,
    customFields,
    containers,
    tableSettings,
    currentCompany,
  );

  return (
    <>
      {modalOpen && <ContainerQuickActionModal open={modalOpen} setOpen={setModalOpen} />}
      <div className='flex flex-grow flex-col gap-4'>
        <div className='flex justify-between gap-2'>
          <SearchFilter
            items={allItems}
            setItems={setItems}
            placeholder={t(TranslationKey.filterContainer).plural.label}
            filter={filter}
          />
          <div className='flex gap-2'>
            <IconButton
              type={IconType.switchVertical1}
              onClick={() => setModalOpen(true)}
              text={t(TranslationKey.move).singular.upper}
            />
            <CreateButton onClick={() => navigate(Routing.stock.containers.create())} />
            {isAdmin && (
              <SettingsIconButton onClick={() => navigate(Routing.stock.containers.settings.containerTypes())} />
            )}
          </div>
        </div>
        <Table
          loading={containersLoading || containerTypesLoading}
          items={items}
          totalItemCount={allItems.length}
          headers={containerTableHeaders(
            tableSettings,
            currentCompany,
            companies,
            stockLocations,
            bins,
            containers,
            containerTypes,
            locale,
          )}
          filter={filter}
          onClick={item => navigate(Routing.stock.containers.detail(item.id))}
        />
      </div>
    </>
  );
}
